import type * as Phaser from "phaser"

/**
 * Set a rectangular physics body using world-pixel dimensions regardless of
 * the sprite's current scale. Useful when you know the desired hitbox in
 * screen pixels but the sprite may be scaled arbitrarily.
 */
export function setRectBodyInWorldPixels(
  sprite: Phaser.Physics.Arcade.Sprite,
  width: number,
  height: number,
  offsetX = 0,
  offsetY = 0,
): void {
  const body = sprite.body as Phaser.Physics.Arcade.Body
  if (!body) return

  const scaleX = sprite.displayWidth / Math.max(sprite.width, 1)
  const scaleY = sprite.displayHeight / Math.max(sprite.height, 1)

  body.setSize(
    width / Math.max(scaleX, 0.001),
    height / Math.max(scaleY, 0.001),
  )
  body.setOffset(
    offsetX / Math.max(scaleX, 0.001),
    offsetY / Math.max(scaleY, 0.001),
  )
}

/**
 * Set a circular physics body using a world-pixel radius regardless of the
 * sprite's current scale.
 */
export function setCircleBodyInWorldPixels(
  sprite: Phaser.Physics.Arcade.Sprite,
  radius: number,
  offsetX = 0,
  offsetY = 0,
): void {
  const body = sprite.body as Phaser.Physics.Arcade.Body
  if (!body) return

  const scaleX = sprite.displayWidth / Math.max(sprite.width, 1)
  const scaleY = sprite.displayHeight / Math.max(sprite.height, 1)
  const scale = Math.min(scaleX, scaleY)

  body.setCircle(
    radius / Math.max(scale, 0.001),
    offsetX / Math.max(scaleX, 0.001),
    offsetY / Math.max(scaleY, 0.001),
  )
}
